import styled from 'styled-components';
import { Checkbox } from 'semantic-ui-react';
import { theme } from '../../styles/theme';

const TickCheckbox = styled(Checkbox)`
  &&& {
    cursor: pointer;
    min-width: 12px;
    min-height: 12px;
    line-height: 12px;

    &.disabled {
      opacity: 0.5;
    }

    &,
    label,
    label:before,
    label:after,
    input {
      width: 12px;
      height: 12px;
      border-radius: 1.5px;
    }

    input:focus ~ label:before,
    input:focus-within ~ label:before,
    label:before {
      border-color: ${theme.colors.secondary800};
    }
    input:focus ~ label:before {
      border-color: ${theme.colors.secondary800};
    }
    label:after {
      background-color: ${theme.colors.secondary800};
    }

    input:checked ~ label:before {
      border-color: ${theme.colors.mainBlue};
    }

    input:checked ~ label:after {
      color: #fff;
      font-size: 11px;
      background-color: ${theme.colors.mainBlue};
    }
  }
`;

export default TickCheckbox;
